import Sidebar from "@/components/layout/Sidebar";
import { Outlet } from "react-router-dom";
import ScrollToTopNavegation from "../ui/scroll-to-top-navegation";
import { ScrollToTop } from "../ui/ScrollToTop";

import Footer from "./Footer";
import { HeaderUser } from "./header/HeaderUser";
import MobileTabs from "./mobile-tabs";

export default function CustomerLayout() {
  return (
    <div className="bg-n-bg-3 flex flex-col min-h-screen">
      <ScrollToTopNavegation />
      <HeaderUser />
      <div className="flex flex-1 items-start">
        <Sidebar />
        <div className="pt-[72px] px-[3%] mx-auto flex-1 pb-16 lg:pb-0">
          <Outlet />
        </div>
      </div>
      <ScrollToTop />
      <MobileTabs />
      <Footer />
    </div>
  );
}
